import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import styled from 'styled-components';

import Title2 from '@joinforma/ui/components/Title2';
import BACKGROUND_PNG from 'assets/images/login-background.png';
import { ReactComponent as Logo } from 'assets/images/logo-colored-with-name.svg';
import { ScreenWidth } from '@joinforma/ui/constants/breakpoints';

import { RootRoutes } from 'utils/routeGenerator';

const Container = styled.main`
  background-color: #fff6e6;
  height: 100vh;
  @media (min-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    background-image: url(${() => BACKGROUND_PNG});
    background-repeat: no-repeat;
    background-size: auto 500px;
    background-position: right 20% bottom 50%;
  }
`;

const Navbar = styled.div`
  height: 100px;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  @media (min-width: ${ScreenWidth.MOBILE_LANDSCAPE}) {
    padding: 27px 32px;
  }
`;

const StyledLogo = styled(Logo)`
  height: 33px;
`;

const ExternalLink = styled.a``;

const AdminLinkText = styled(Title2)`
  color: ${({
    theme: {
      colors: {
        text: { link },
      },
    },
  }) => link};
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  @media (min-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    width: 70%;
  }
`;

const LoginLayout = () => (
  <Container>
    <Navbar>
      <Link to={RootRoutes.login()}>
        <StyledLogo />
      </Link>
      <ExternalLink
        href={
          process.env.REACT_APP_ADMIN_LOGIN_URL ||
          'https://admin.joinforma.com/signin'
        }
      >
        <AdminLinkText>Employer Sign In</AdminLinkText>
      </ExternalLink>
    </Navbar>
    <Content>
      <Outlet />
    </Content>
  </Container>
);

export default LoginLayout;
